import { Container, Row, Col, Button } from 'react-bootstrap';

// Import capability images
import { useNavigate } from 'react-router-dom';

import galleryOne from '../assets/images/gallery/gallery-1.jpg';
import galleryTwo from '../assets/images/gallery/gallery-2.jpg';
import galleryThree from '../assets/images/gallery/gallery-3.jpg';
import galleryFour from '../assets/images/gallery/gallery-4.jpg';
import galleryFive from '../assets/images/gallery/gallery-5.jpg';

const OurWorks = () => {

    const navigate = useNavigate();

    return (
        <section>
            <Container fluid>
                <Row>
                    <Col md={11} lg={10} className="mx-auto">
                        <div className="d-lg-flex gallery">
                            <div className="galleryItem" style={{ backgroundImage: `url(${galleryOne})` }}>
                                <div className='overlay-wrapper'>
                                    <h1 className='rotate-text'>Architecture & Interior</h1>
                                    <div className="overlay">
                                        <div>
                                            <h1 className="gallery-title text-nowrap">Architecture & Interior Designing</h1>
                                            {/* <span className="gallery-desc text-nowrap">SDS | Design Triangle | Mahive </span> */}
                                             <Button variant="theme" className={`btn-rounded small mt-4 mb-3`} onClick={() => {navigate('/services')}}>
                                                <span className="fs-14 fw-500">Know More</span>
                                                <span className="arrow-icon">
                                                    <i className="fa-solid fa-arrow-right icon"></i>
                                                    <i className="fa-solid fa-arrow-right icon"></i>
                                                </span>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="galleryItem" style={{ backgroundImage: `url(${galleryTwo})` }}>
                                <div className='overlay-wrapper'>
                                    <h1 className='rotate-text'>Builders & Real Estat</h1>
                                    <div className="overlay">
                                        <div>
                                            <h1 className="gallery-title text-nowrap">Builders & Real Estate</h1>
                                            {/* <span className="gallery-desc text-nowrap"> DAC | Emarah Properties | Hameedia Realty</span> */}
                                            <Button variant="theme" className={`btn-rounded small mt-4 mb-3`} onClick={() => {navigate('/services')}}>
                                                <span className=" fs-14 fw-500">Know More</span>
                                                <span className="arrow-icon">
                                                    <i className="fa-solid fa-arrow-right icon"></i>
                                                    <i className="fa-solid fa-arrow-right icon"></i>
                                                </span>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="galleryItem" style={{ backgroundImage: `url(${galleryThree})` }}>
                                <div className='overlay-wrapper'>
                                    <h1 className='rotate-text'>Healthcare Services</h1>
                                    <div className="overlay">
                                        <div>
                                            <h1 className="gallery-title text-nowrap">Cosmetology & HealthCare</h1>
                                            {/* <span className="gallery-desc text-nowrap"> AdGro & AdGlo | Fillr By Dr. F </span> */}
                                             <Button variant="theme" className={`btn-rounded small mt-4 mb-3`} onClick={() => {navigate('/services')}}>
                                                <span className=" fs-14 fw-500">Know More</span>
                                                <span className="arrow-icon">
                                                    <i className="fa-solid fa-arrow-right icon"></i>
                                                    <i className="fa-solid fa-arrow-right icon"></i>
                                                </span>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="galleryItem" style={{ backgroundImage: `url(${galleryFour})` }}>
                                <div className='overlay-wrapper'>
                                    <h1 className='rotate-text'>Travel & Tourism</h1>
                                    <div className="overlay">
                                        <div>
                                            <h1 className="gallery-title text-nowrap">Travel & Tourism</h1>
                                            {/* <span className="gallery-desc text-nowrap">Bushra Haj Services | Hameedia Haj Services</span> */}
                                             <Button variant="theme" className={`btn-rounded small mt-4 mb-3`} onClick={() => {navigate('/services')}}>
                                                <span className=" fs-14 fw-500">Know More</span>
                                                <span className="arrow-icon">
                                                    <i className="fa-solid fa-arrow-right icon"></i>
                                                    <i className="fa-solid fa-arrow-right icon"></i>
                                                </span>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="galleryItem" style={{ backgroundImage: `url(${galleryFive})` }}>
                                <div className='overlay-wrapper'>
                                    <h1 className='rotate-text'>E-commerce & Other</h1>
                                    <div className="overlay">
                                        <div>
                                            <h1 className="gallery-title text-nowrap"> E-commerce & Other</h1>
                                            {/* <span className="gallery-desc text-nowrap">Kawatihi | Mahira Mohsin | Franchise Thalaiva</span> */}
                                             <Button variant="theme" className={`btn-rounded small mt-4 mb-3`} onClick={() => {navigate('/services')}}>
                                                <span className=" fs-14 fw-500">Know More</span>
                                                <span className="arrow-icon">
                                                    <i className="fa-solid fa-arrow-right icon"></i>
                                                    <i className="fa-solid fa-arrow-right icon"></i>
                                                </span>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Col>
                </Row>
            </Container>

        </section>
    );
};

export default OurWorks;
